import React, { useState } from "react";
import { Col, Row } from "react-bootstrap";
import Svg from "../../../../assets/Svgs/Svg";
import styled from "styled-components";
import { data } from "../../../../Data/data";
import { Link } from "react-router-dom";
import ButtonComp from "../../../../Components/ButtonComp";
import useMediaQuery from "../../../../hooks/useMediaQuery";

const textDecorators = (text, condition) => {
   let [string, lastString] = text.split(/\n/g);
   let [, afterAmpersand] = string.split(/\&/g);
   //
   let finalString = !condition && string.includes("&") ? string.replace(`&${afterAmpersand}`, `& <span style="color:#FF5101">${afterAmpersand}</span>`) : string;

   if (condition) {
      return `${finalString}<br>${lastString ? lastString : ""}`;
   } else {
      return `${finalString}<br><span style="color:#FF5101">${lastString ? lastString : ""}</span>`;
   }
};

const Card = ({ image, heading, description, link, lgBreakpoint }) => {
   return (
      <div>
         <img src={image} alt="no image" className="d-block" style={{ width: "100%", marginBottom: "30px" }} />
         <div className="row align-items-center">
            <div className="col-6">
               <span //
                  className="font-35 font-sm-22 line-height-sm-25 text-white line-height-45 d-block fBold"
                  dangerouslySetInnerHTML={{ __html: textDecorators(heading, false) }}
               />
            </div>
            <div className="col-6 d-flex justify-content-end">
               <Link to={link} style={!lgBreakpoint ? { zoom: "0.8" } : {}}>
                  <ButtonComp title="LEARN MORE" isDefaultWhite />
               </Link>
            </div>
         </div>
         <span className="d-block font-16 font-DMSans text-white pt35">{description}</span>
      </div>
   );
};
export default function DigitalSolutions2() {
   const [currentIndex, setCurrentIndex] = useState(0);
   const lgBreakpoint = useMediaQuery("(min-width: 991px)");
   return (
      <Style>
         <Row className="gy-4">
            <Col xs={12} sm={12} md={5} lg={4} xl={4}>
               <Row className="gx-3">
                  {/* loop */}
                  {data.digitalSolutions.map((solution, idx) => (
                     <React.Fragment>
                        <Col
                           xs={4}
                           sm={4}
                           md={12}
                           lg={12}
                           xl={12}
                           className={`pointer ${currentIndex === idx ? "witmates-theme-bg" : ""}`}
                           style={{ padding: "10px" }}
                           onClick={() => setCurrentIndex(idx)}>
                           <span
                              className="d-block font-sm-14 font-28 text-white line-height-sm-20 line-height-40 my-2 fBold"
                              dangerouslySetInnerHTML={{ __html: textDecorators(solution.title, currentIndex === idx) }}
                           />
                        </Col>
                     </React.Fragment>
                  ))}
                  {/*  */}
               </Row>
            </Col>
            <Col xs={12} sm={12} md={7} lg={8} xl={8}>
               {data.digitalSolutions.map(
                  (solution, idx) =>
                     currentIndex === idx && (
                        <React.Fragment>
                           <Card //
                              lgBreakpoint={lgBreakpoint}
                              image={solution.img}
                              heading={solution.title}
                              description={solution?.description}
                              link={solution.linkTo}
                           />
                        </React.Fragment>
                     )
               )}
            </Col>
         </Row>
      </Style>
   );
}
const Style = styled.div`
   margin-top: 40px;
   .number-bar {
      position: relative;
   }
   .number-bar::before {
      content: "";
      width: 117.5px;
      border: 1px solid white;
      height: 1px;
      display: block;
      position: absolute;
      top: 25px;
      left: 41px;
   }
   /* .item {
      min-width: 312px;
      max-width: 312px;
   } */
   .scroll-container {
      display: block;
   }
   @media only screen and (max-width: 766px) {
      & {
         margin-top: 40px;
      }
      .item {
         min-width: 100%;
         max-width: 100%;
      }
      .scroll-container {
         margin-bottom: 12px;
      }
   }
`;
